import {Component, Inject, OnInit} from "@angular/core";
import {AlertService, AuthenticationService} from "../../_services";
import {Router} from "@angular/router";
import {LoginHelper} from "../../helpers";
import {User} from "../../_models";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: "select-action-plan-template",
  templateUrl: 'select-action-plan-template.component.html',
  styleUrls: ['./select-action-plan-template.component.scss'],
})
export class SelectActionPlanTemplateComponent implements OnInit {
  actionPlanTemplates: any[] = [];
  currentUser: User;
  recurringList: any;
  rowGroupMetadata: any;
  isLink: boolean;

  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<SelectActionPlanTemplateComponent>) {
    this.actionPlanTemplates = data.actionPlanTemplates;
    this.updateRowGroupMetaData();
    this.isLink = data.isLink;
  }

  ngOnInit() {
  }
  selectActionPlanTemplate(data)
  {
    this.dialogRef.close(data);
  }

  addToken(html) {
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }

  updateRowGroupMetaData() {
      const data = this.actionPlanTemplates;
      this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        rowData.category = rowData.category || ' ';
        let brand = rowData.category || ' ';
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.category || ' ';
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

}
